import axios_ from "../utils/axios";

export default {
  getGptConfigDatas() {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/config/datas`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getGptModels() {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/getGptModel`, { page: 1 })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取图片验证码接口
   * @return {*}
   */
  getCaptchas() {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/captchas`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 发送短信验证码接口
   * @returns
   */
  sendSmsCode(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/sendSmsCode`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 手机号登录注册接口
   * @returns
   */
  phoneLogin(data) {
    const requestQuery = {
      ...data,
      source: 2, // 表示 JOINMC
    };
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/phoneLogin`, requestQuery)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 账号密码登录
   * @returns
   */
  numberLogin(data) {
    const requestData = {
      ...data,
      source: 2, // 表示 JOINMC
    };
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/login`, requestData)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 手机号/邮箱注册
   * @returns
   */
  phoneRegister(data, flag) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/${flag ? "mobileRegister" : "emailRegister"}`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 邮箱验证码
   * @returns
   */
  registerSendEmailCode(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/sendEmailCode2`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 修改密码
   * @returns
   */
  ResetPassword(data, flag) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/${flag ? "mobileResetPassword" : "emailResetPassword"}`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 工作台跳转登录注册接口
   * @returns
   */
  redirectLogin(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/singleSignOn`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 退出登录
   * @returns
   */
  logout() {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/logout`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 个人信息
   * @returns
   */
  personalInformation() {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/userCenter/detail`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 修改昵称
   * @returns
   */
  editNickName(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/editNickName`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 短信验证码
   * @returns
   */
  postSendSmsCode(data, flag) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/${flag ? "sendSmsCode" : "sendEmailCode"}`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 验证短信验证码
   * @returns
   */
  authVeriCodeTwo(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/authVeriCodeTwo`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 修改手机号
  editPhoneStore(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/editPhoneStore`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 添加手机号
  addPhoneStore(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/addPhoneStore`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 验证旧邮箱验证码
  authEmailCode(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/authEmailCode`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 添加/修改邮箱
  addOrEditEmailStore(data) {
    return new Promise((resolve, reject) => {
      axios_(
        "POST",
        `api/pandagpt/v1/userCenter/${data?.auth_verification_key ? "editEmailStore" : "addEmailStore"}`,
        data
      )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 上传头像
  uploadImg(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/uploadImg`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 设置账号密码
  setAccountPassword(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/setAccountPassword`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 更换密码
  editPassword(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/setPassword`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 修改账号
  editAccount(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/setAccount`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 跳过账号密码设置
  skipPerfectStatus() {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/userCenter/skipPerfectStatus`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  // 获取加入的团队
  getUserTeamLists(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/getUserTeamLists`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 退出团队
   * @param {*} data
   * @returns
   */
  exitTeam(data) {
    return axios_("POST", `api/pandagpt/v1/team/exitTeam`, data);
  },
  /**
   * 新手引导状态保存
   * @description 若已经进行过新手引导则将当前页面路由 path 传入保存
   * @param {*} data
   * @property {string} guide_project
   * @returns
   */
  saveGuideStatus(data) {
    return axios_("POST", `api/pandagpt/v1/func_guide/setting_guide`, data, false, false, true);
  },
};

/**
 * joinmc授权绑定joinspark
 * @param {*} data
 * @property {string} verification_code
 * @property {string} verification_key
 * @returns <Promise<{code: number, data: {check_token: string}>>
 */
export const threeAuthorize = (data) => {
  return axios_("POST", `api/pandagpt/v1/team/threeAuthorize`, data, false, false, false, false);
};
